export default function Hero() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20fashion%20lifestyle%20flat%20lay%20photography%20featuring%20premium%20sneakers%20leather%20accessories%20cotton%20hoodie%20and%20minimalist%20watch%20artfully%20arranged%20on%20warm%20terracotta%20textured%20surface%2C%20soft%20natural%20morning%20light%20casting%20gentle%20organic%20shadows%2C%20dried%20pampas%20grass%20and%20linen%20fabric%20accents%2C%20earthy%20neutral%20color%20palette%20cream%20sand%20olive%20tones%2C%20editorial%20catalog%20aesthetic%20with%20abundant%20negative%20space%2C%20refined%20modern%20composition&width=1600&height=900&seq=hero-fashion-lifestyle-2026r2&orientation=landscape"
          alt="Hipobuy Spreadsheet product showcase with premium fashion items and warm natural lighting"
          title="Hipobuy Spreadsheet - Product Research & Shopping Guide"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/30"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-20">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-5 leading-tight">
          Hipobuy Spreadsheet 2026
        </h1>
        <p className="text-base md:text-lg text-white/85 max-w-2xl mx-auto mb-10 leading-relaxed">
          The ultimate product research and shopping guide resource center. Discover thousands of products, compare prices, and shop smarter with our comprehensive spreadsheet tools.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto bg-primary-500 hover:bg-primary-600 text-background-50 px-8 py-3.5 rounded-md text-base font-semibold transition-all duration-200 whitespace-nowrap cursor-pointer inline-block"
          >
            Hipobuy Sheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto bg-white/95 hover:bg-white text-foreground-900 px-8 py-3.5 rounded-md text-base font-semibold transition-all duration-200 whitespace-nowrap cursor-pointer inline-block"
          >
            Buy It Now
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 mt-10">
          <span className="flex items-center gap-2 text-white/80 text-sm">
            <i className="ri-check-line text-accent-400"></i>
            Updated Resources
          </span>
          <span className="flex items-center gap-2 text-white/80 text-sm">
            <i className="ri-check-line text-accent-400"></i>
            Product Comparison
          </span>
          <span className="flex items-center gap-2 text-white/80 text-sm">
            <i className="ri-check-line text-accent-400"></i>
            QC Shopping Tips
          </span>
          <span className="flex items-center gap-2 text-white/80 text-sm">
            <i className="ri-check-line text-accent-400"></i>
            Beginner Friendly
          </span>
        </div>
      </div>
    </section>
  );
}